import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Router } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  idUser: number;
  private readonly swCheckIntervalMs = 5 * 60 * 1000;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private authenticationService: AuthenticationService,
    private router: Router,
    private translate: TranslateService,
    private readonly swUpdate: SwUpdate
  ) {
    this.translate.addLangs(['en', 'it', 'fr', 'es']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      if (this.authenticationService.isLoggedIn()) {
        this.router.navigate(['main']);
      } else {
        this.router.navigate(['login']);
      }

      this.watchForUpdate();
    });
  }

  private watchForUpdate() {
    if (!this.swUpdate.isEnabled) {
      return;
    }
    this.swUpdate.available.subscribe(() => {
      document.location.reload();
    });
    this.swUpdate.checkForUpdate().catch(() => null);
    window.setInterval(() => {
      this.swUpdate.checkForUpdate().catch(() => null);
    }, this.swCheckIntervalMs);
  }
}
